export default __webpack_public_path__ + "static/media/p2_pfd.4aa5925c.jpg";